import { createContext, useState } from "react";

export const ThemeContext = createContext(null);
export const ThemeContextProvider = ({ children }) => {
  const [theme, setTheme] = useState(true);
  const [animateBtn, setAnimateBtn] = useState(null);
  const [path, setPath] = useState(window.location.pathname);

  return (
    <ThemeContext.Provider
      value={{ theme, setTheme, animateBtn, setAnimateBtn, path, setPath }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
